import type { HealthHistoryQuery, HealthHistoryResponse } from '@ofmos/shared/health-history';
import type { IntakeReviewed } from '@ofmos/shared/intake-reviewed';
import type { ReplyHandled } from '@ofmos/shared/reply-handled';
import type { FulfillmentClient } from '../client';
import type { Transport } from './transport';

/**
 * `FulfillmentClient` over `/api/fulfillment/*`, as thin as `HttpFeedsClient`: the shape is
 * `replyHandledSchema` in `@ofmos/shared/reply-handled`, decided once on the server. No body
 * is sent: the time is the server's (redesign D2).
 */
export class HttpFulfillmentClient implements FulfillmentClient {
  constructor(private readonly transport: Transport) {}

  markReplyHandled(agencyId: string): Promise<ReplyHandled> {
    return this.transport.request<ReplyHandled>({
      method: 'POST',
      path: `/api/fulfillment/agencies/${agencyId}/reply-handled`,
    });
  }

  clearReplyHandled(agencyId: string): Promise<ReplyHandled> {
    return this.transport.request<ReplyHandled>({
      method: 'DELETE',
      path: `/api/fulfillment/agencies/${agencyId}/reply-handled`,
    });
  }

  /** "Mark as reviewed" (redesign D10, ledger BE-INR): no body, the time is the server's. */
  markIntakeReviewed(submissionId: string): Promise<IntakeReviewed> {
    return this.transport.request<IntakeReviewed>({
      method: 'POST',
      path: `/api/intake/submissions/${submissionId}/reviewed`,
    });
  }

  clearIntakeReviewed(submissionId: string): Promise<IntakeReviewed> {
    return this.transport.request<IntakeReviewed>({
      method: 'DELETE',
      path: `/api/intake/submissions/${submissionId}/reviewed`,
    });
  }

  /** `GET /api/fulfillment/health-history?since=&owner=` (record 11); `owner` absent is all. */
  healthHistory(query: HealthHistoryQuery): Promise<HealthHistoryResponse> {
    return this.transport.request<HealthHistoryResponse>({
      method: 'GET',
      path: '/api/fulfillment/health-history',
      query: { since: query.since, owner: query.owner },
    });
  }
}
